import React from 'react';

export default function RefundPolicy() {
  return (
    <div className="pt-28 pb-20 bg-amber-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="section-title mb-10">Membership Refund Policy</h1>

        <div className="space-y-6 text-amber-800 leading-relaxed">
          <p>
            Membership contributions made to BSM Bhojan Seva Mandal Foundation are voluntary and
            are generally non-refundable.
          </p>

          <p>
            In case of accidental duplicate payments, technical issues, or
            unauthorized transactions, members may contact us within 7 days of the payment.
          </p>

          <p>
            Refund requests will be reviewed on a case-by-case basis and, if
            approved, processed through the original payment method.
          </p>

          <p>
            For refund-related assistance, please contact us through the Contact
            Us page with transaction details, including the subscription ID/ transaction ID and membership amount.
          </p>
        </div>
      </div>
    </div>
  );
}